import React from "react";
import PropTypes from "prop-types";

import {LOWES_DISCLAIMER_EN} from "../../../misc/fabricatorHardcode";

const warningIcon = `https://qc-cdn.s3.amazonaws.com/receipt/icon-warning-red.jpg`;

const PrintDocumentDisclaimer = (props) => {
  const {fabricatorData, locale, styles, withTotal, messages, showPrice} = props;
  const fabricatorSettings = fabricatorData.settings;

  const {View, Text, Image} = window.ReactPdfRenderer;

  if (!fabricatorSettings.depositDisclaimer || !fabricatorSettings.enableDisclaimer) {
    return null
  }

  const hugeDisclaimer = fabricatorSettings.depositDisclaimer.length >= 1500;

  const hideDisclaimer = (withTotal && hugeDisclaimer) // we will display it below total, full width
    || (showPrice && !withTotal && !hugeDisclaimer) // it should be in left, or full

  if (hideDisclaimer) {
    return null
  }

  const getDisclaimerMessage = () => {
    if ((fabricatorData.isLowes || fabricatorData.isCaesarStone)) {
      if (locale === "fr-FR" && messages["transDoc.description_FR._disclaimer"]) {
        return messages["transDoc.description_FR._disclaimer"]
      } else if (locale === "pl-PL" && messages["transDoc.customTranslateDescription_PL._disclaimer"]) {
        return messages["transDoc.customTranslateDescription_PL._disclaimer"]
      } else if (messages["transDoc.customDisplayName_FR._disclaimer"]) { // it is actually EN ! hardcoded for lowes profiles
        return messages["transDoc.customDisplayName_FR._disclaimer"]
      } else if (fabricatorData.isLowes) {
        return LOWES_DISCLAIMER_EN
      }
    }
    return fabricatorSettings.depositDisclaimer
  }

  const disclaimerMessage = getDisclaimerMessage();

  // if (withTotal) {
  //   return (
  //     <View style={styles.notification}>
  //       <Image style={styles.notificationImage} src={warningIcon} />
  //       <Text style={styles.notificationText}>{disclaimerMessage}</Text>
  //     </View>
  //   )
  // }

  return (
    <View style={withTotal ? styles.notification : [styles.notification, styles.notificationMargin]}>
      <Image style={styles.notificationImage} src={warningIcon} />
      <Text style={showPrice && !hugeDisclaimer ? [styles.notificationText, styles.red] : styles.red}>
        {disclaimerMessage}
      </Text>
    </View>
  )

};

PrintDocumentDisclaimer.propTypes = {
  fabricatorData: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  withTotal: PropTypes.bool,
};

export default PrintDocumentDisclaimer
